import { RESET_POINT_OF_SALE_STATE } from '@dynameat/views/pointOfSale/mutationTypes';
import * as MutationTypes from './mutationTypes';
import { PRINT_MENU_SECTION_REQUEST } from './mutationTypes';

const noAction = () => {
};

const momentOfConsumeListSuccess = (state, payload) => {
  state.momentOfConsumeList = payload;
};

const resetPointOfSaleState = (state) => {
  state.menuList = [];
  state.momentOfConsumeList = [];
  state.menuSectionTypesList = [];
  state.templateList = [];
};

const menuSectionTypesSuccess = (state, menuSectionTypesList) => {
  state.menuSectionTypesList = menuSectionTypesList;
};

const templateListSuccess = (state, templateList) => {
  state.templateList = templateList;
};

const menuFontListSuccess = (state, menuFontList) => {
  state.menuFontList = menuFontList;
};

const createMenuFontsSuccess = (state, font) => {
  state.menuFontList.push(font);
};

const deleteMenuFontsSuccess = (state, guid) => {
  const fontIndex = state.menuFontList.findIndex((f) => f.guid === guid);
  state.menuFontList.splice(fontIndex, 1);
};

const printMenuSection = (state, sectionList) => {
  state.printMenuSectionList = sectionList;
};

const menuPrintConfiguration = (state, menuPrintConfigurationData) => {
  state.menuPrintConfiguration = menuPrintConfigurationData;
};

const menuGridConfiguration = (state, menuGridConfigurationData) => {
  state.menuGridConfiguration = menuGridConfigurationData;
};

export const mutations = {
  [MutationTypes.MENU_CONFIGURATION_SUCCESS]: noAction,
  [MutationTypes.EDIT_MENU_CONFIGURATION_SUCCESS]: noAction,
  [MutationTypes.THEME_SUCCESS]: noAction,
  [MutationTypes.EDIT_THEME_SUCCESS]: noAction,
  [MutationTypes.MOMENT_OF_CONSUME_LIST_SUCCESS]: momentOfConsumeListSuccess,
  [MutationTypes.MENUSECTION_TYPES_SUCCESS]: menuSectionTypesSuccess,
  [MutationTypes.TEMPLATE_LIST_SUCCESS]: templateListSuccess,
  [MutationTypes.MENU_FONTS_LIST_SUCCESS]: menuFontListSuccess,
  [MutationTypes.CREATE_MENU_FONTS_SUCCESS]: createMenuFontsSuccess,
  [MutationTypes.DELETE_MENU_FONTS_SUCCESS]: deleteMenuFontsSuccess,
  [RESET_POINT_OF_SALE_STATE]: resetPointOfSaleState,
  [MutationTypes.PRINT_MENU_SECTION_REQUEST]: printMenuSection,
  [MutationTypes.MENU_PRINT_CONFIGURATION_REQUEST]: menuPrintConfiguration,
  [MutationTypes.MENU_GRID_CONFIGURATION_SUCCESS]: menuGridConfiguration,
};
